import { Link } from "react-router-dom";
import { RouterPath } from "routes/routerPaths";
import { publicPath } from "request";
import { FormattedMessage } from "react-intl";

const DashboardPage = () => {
  return (
    <div className="w-full">
      <div
        className="w-full px-5 py-4 md:py-8 2xl:px-[60px] 2xl:py-10 text-white"
        style={{
          background: "linear-gradient(254deg, #26252b 0%, #121214 100%)",
        }}
      >
        <div className="max-w-[1600px] my-0 mx-auto">
          <img
            src={`${publicPath}/icons/ic_logo.png`}
            alt=""
            className="w-12 md:w-24 h-12 md:h-24 ml-5 md:ml-10"
          />
          <div className="font-medium text-white relative">
            <div className="opacity-10 text-[84px] md:text-[144px] md:pl-6">
              <FormattedMessage id="dashboard.brand" />
            </div>
            <p className="text-[48px] md:text-[72px] font-medium mb-5 absolute top-[60%] left-2 md:left-8 lg:left-10 translate-y-[-60%] z-[1] text-white opacity-90">
              <FormattedMessage id="dashboard.brand" />
            </p>
          </div>
          <div className="w-[52px] h-1 md:h-2 flex-shrink-0 bg-white opacity-90 ml-2 md:ml-10"></div>
          <p className="opacity-80 text-base md:text-lg leading-6 md:leading-7 lg:leading-[42px] mt-5 ml-2 md:ml-10">
            <FormattedMessage id="dashboard.description" />
          </p>
          <a
            href="https://medcursor.com"
            target="_blank"
            rel="noreferrer"
            className="no-underline text-white"
          >
            <div className="px-5 py-3 w-fit flex items-center justify-center md:text-lg bg-primary mt-8 md:mt-10 cursor-pointer rounded-xl ml-2 md:ml-10">
              <FormattedMessage id="dashboard.goTotheWebsite" />
            </div>
          </a>
        </div>
      </div>

      <div className="w-full px-6 md:px-[60px] text-[#333] py-10 bg-[#e6e9f3]">
        <div className="lg:pl-10 max-w-[1200px] my-0 mx-auto flex items-center justify-between flex-col lg:flex-row gap-[10%]">
          <div>
            <span className="text-2xl text-center lg:text-left md:text-[32px] font-semibold w-full inline-block">
              <FormattedMessage id="dashboard.smartBloodPressureMonitor" />
            </span>
            <div className="text-[#333] mt-5 md:mt-10 md:text-lg">
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartBloodPressureMonitorFeature1" />
              </p>
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartBloodPressureMonitorFeature2" />
              </p>
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartBloodPressureMonitorFeature3" />
              </p>
            </div>
          </div>
          <div className="mt-12 flex items-center justify-center">
            <img
              src={`${publicPath}/images/home/smart-blood-pressure-monitor@2x.png`}
              className="max-w-[80%] lg:max-w-[230px]"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="w-full px-6 md:px-[60px] text-white opacity-90 py-10 bg-[#2b2d32]">
        <div className="lg:pl-10 max-w-[1200px] my-0 mx-auto flex flex-col lg:flex-row-reverse items-center justify-between gap-[10%]">
          <div>
            <p className="text-2xl text-center lg:text-left md:text-[32px] font-semibold w-full inline-block">
              <FormattedMessage id="dashboard.smartFootMassager" />
            </p>
            <div className="text-white opacity-90 mt-5 md:mt-10 md:text-lg">
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartFootMassagerFeature1" />
              </p>
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartFootMassagerFeature2" />
              </p>
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartFootMassagerFeature3" />
              </p>
            </div>
          </div>
          <div className="mt-12 flex items-center justify-center">
            <img
              src={`${publicPath}/images/home/smart-foot-massager@2x.png`}
              className="max-w-[80%] lg:max-w-[230px]"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="w-full px-6 md:px-[60px] text-[#333] py-10 bg-[#e6e9f3]">
        <div className="lg:pl-10 max-w-[1200px] my-0 mx-auto flex items-center justify-between flex-col lg:flex-row gap-[10%]">
          <div>
            <span className="text-2xl text-center lg:text-left md:text-[32px] font-semibold w-full inline-block">
              <FormattedMessage id="dashboard.smartWhiteNoise" />
            </span>
            <div className="text-[#333] mt-5 md:mt-10 md:text-lg">
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartWhiteNoiseFeature1" />
              </p>
              <p className="pl-[30px] mt-[5px] relative inline-block before:content-['-'] before:absolute before:left-4 before:text-xl">
                <FormattedMessage id="dashboard.smartWhiteNoiseFeature2" />
              </p>
            </div>
          </div>
          <div className="mt-12 flex items-center justify-center">
            <img
              src={`${publicPath}/images/home/smart-white-noise@2x.png`}
              className="max-w-[80%] lg:max-w-[230px]"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="w-full p-5 md:p-10 flex flex-row items-center justify-around bg-[#2b2d32] md:text-lg ">
        <Link to={`/${RouterPath.userTerms}`}>
          <button className="bg-transparent text-primary">
            <FormattedMessage id="dashboard.termsOfUse" />
          </button>
        </Link>
        <Link to={`/${RouterPath.privacy}`}>
          <button className="bg-transparent text-primary">
            <FormattedMessage id="dashboard.privacyPolicy" />
          </button>
        </Link>
      </div>
    </div>
  );
};
export default DashboardPage;
